import React, { useEffect, useState } from 'react';
import { Section } from '../index';
import { GatsbyImage } from "gatsby-plugin-image";
import { isBrowser } from '../../../model/util';
import classNames from 'classnames';
import BipLogo from "../../../assets/svgs/logo-bip.svg";

const BooksInProgressSection = ({issue}) => {
  const {
    tghpwipIssuesTaxonomyColor: issueColor,
    tghpwipIssuesTaxonomyBipsectionSection: sectionId,
    tghpwipIssuesTaxonomyFeaturedImage: featuredImage,
    tghpwipIssuesTaxonomyBipsectionCtaText: ctaText
  } = issue;

  const [sectionData, setSectionData] = useState(null);

  useEffect(() => {
    if (!isBrowser) return;

    const fetchSection = async () => {
      const data = await (await fetch(
        `https://books.worksinprogress.co/api/content/detail`
      )).json();

      if (!data || !data.sections) return;

      if (data.sections[sectionId]) {
        setSectionData(data.sections[sectionId]);
      }
    }

    fetchSection();
  }, [sectionId]);

  return (
    <Section
      type="books-in-progress-section"
      issue={issue}
      color={issueColor ? issueColor : `black`}
      expandButtonLocation={false}
    >
      <div className={classNames([
        'books-in-progress-section-issue-grid__image',
        featuredImage?.nodes.length > 0 && 'books-in-progress-section-issue-grid__image--visible',
      ])}>
        {featuredImage?.nodes.length > 0 && (
          <GatsbyImage
            image={featuredImage?.nodes[0]?.gatsbyImage}
            sizes="(min-width: 720px) 60vw, 50vw"
            alt={featuredImage?.nodes[0]?.altText}
          />
        )}
      </div>
      <div className="books-in-progress-section-issue-grid__body">
        <div className={classNames([
          'books-in-progress-section-issue-grid__body-inner',
          'books-in-progress-section-issue-grid__body-inner--skeletons',
        ])}>
          <div className="books-in-progress-section-issue-grid__body-header">
            <div className="books-in-progress-section-issue-grid__body-header-bip-label">
              <div className="skeleton"></div>
            </div>
          </div>
          <div className="books-in-progress-section-issue-grid__body-section">
            <div className="books-in-progress-section-issue-grid__body-section-manuscript">
              <div className="books-in-progress-section-issue-grid__body-section-manuscript-title">
                <div className="skeleton"></div>
              </div>
              <div className="books-in-progress-section-issue-grid__body-section-manuscript-author">
                <div className="skeleton"></div>
              </div>
            </div>
            <div className="books-in-progress-section-issue-grid__body-section-title">
              <div className="skeleton"></div>
            </div>
            <div className="books-in-progress-section-issue-grid__body-section-cta">
              <div className="skeleton"></div>
            </div>
            <div className="books-in-progress-section-issue-grid__body-section-buttons">
              <div className="skeleton"></div>
            </div>
          </div>
        </div>
        <div className={classNames([
          'books-in-progress-section-issue-grid__body-inner',
          !!sectionData && 'books-in-progress-section-issue-grid__body-inner--visible',
        ])}>
          {!!sectionData &&
            <>
              <div className="books-in-progress-section-issue-grid__body-header">
                <div className="books-in-progress-section-issue-grid__body-header-bip-label">
                  <BipLogo />
                </div>
              </div>
              <div className="books-in-progress-section-issue-grid__body-section">
                <div className="books-in-progress-section-issue-grid__body-section-manuscript">
                  <div className="books-in-progress-section-issue-grid__body-section-manuscript-title">
                    {sectionData?.manuscript?.title}
                  </div>
                  <div className="books-in-progress-section-issue-grid__body-section-manuscript-author">
                    by {sectionData?.manuscript?.author}
                  </div>
                </div>
                <div className="books-in-progress-section-issue-grid__body-section-title">
                  {sectionData?.section?.title}
                </div>
                {ctaText &&
                  <div className="books-in-progress-section-issue-grid__body-section-cta">
                    {ctaText}
                  </div>
                }
                {sectionData?.section?.revision &&
                  <div className="books-in-progress-section-issue-grid__body-section-buttons">
                    <a href={sectionData.section.revision?.url} target="_blank" className="books-in-progress-section-issue-grid__button" rel="noreferrer">
                      Read more
                    </a>
                  </div>
                }
              </div>
            </>
          }
        </div>
      </div>
    </Section>
  );
};

export default BooksInProgressSection;
